import {colors} from '@material-ui/core';
import {Permission, Role, User} from './auth';

export interface WcvLog {
  id: number
  level: number
  type: number
  type_id?: number
  code: string
  description: string
  resolved: boolean
  user?: User
  payload: string
  created_at: Date

  targetUser?: User,
  targetRole?: Role,
  targetPermission?: Permission,
}

export const WcvLogLevel = {
  OFF: 0,
  FATAL: 1,
  ERROR: 2,
  WARN: 3,
  INFO: 4,
  DEBUG: 5,
  NOTE: 6,
};

export const WcvLogLevels = [
  {name: 'off', colour: colors.grey[600]},
  {name: 'fatal', colour: colors.red[600]},
  {name: 'error', colour: colors.orange[600]},
  {name: 'warn', colour: colors.yellow[600]},
  {name: 'info', colour: colors.green[600]},
  {name: 'debug', colour: colors.blue[600]},
  {name: 'note', colour: colors.grey[600]},
];

export const WcvType = {
  SYSTEM: 0,
  USER: 1,
  ROLE: 2,
  PERMISSION: 3,
  COMMUNICATION: 4,
  REPORT: 5,
  RESOURCE: 6,
  RESOURCE_BANK: 7,
  RESOURCE_OPTION: 8,
  GROUP: 9,
  GROUP_MEMBER: 10,
  ROOM_PARTY_MEMBER_OPTION: 11,
  ROOM_PARTY: 12,
  ROOM_PARTY_MEMBER: 13,
  BILLING_PARTY: 14,
  BILLING_PARTY_MEMBER: 15,
  GROUP_BOOKING: 16,
  ROOM_PARTY_OPTION: 17,
  DOCUMENT: 18,
  PAYMENT: 19,
  EMAIL_MGMT: 20,
  STATE: 23,
};

export const WcvTypes = [
  {name: 'system', colour: colors.grey[600]},
  {name: 'user', colour: colors.red[600]},
  {name: 'role', colour: colors.orange[600]},
  {name: 'permission', colour: colors.yellow[600]},
  {name: 'communication', colour: colors.blue[600]},

  {name: 'report', colour: colors.grey[600]},
  {name: 'resource', colour: colors.red[600]},
  {name: 'resource bank', colour: colors.orange[600]},
  {name: 'resource option', colour: colors.yellow[600]},
  {name: 'group', colour: colors.blue[600]},
  {name: 'group member', colour: colors.blue[600]},
  {name: 'room party member option', colour: colors.blue[600]},
  {name: 'room party', colour: colors.blue[600]},
  {name: 'room party member', colour: colors.blue[600]},
  {name: 'billing party', colour: colors.blue[600]},
  {name: 'billing party member', colour: colors.blue[600]},
  {name: 'group booking', colour: colors.blue[600]},
  {name: 'room party option', colour: colors.blue[600]},
  {name: 'document', colour: colors.blue[600]},
  {name: 'payment', colour: colors.blue[600]},
  {name: 'email management', colour: colors.blue[600]},
];

export const getWcvType = (typeId: number) => {
  if (WcvTypes[typeId]) return WcvTypes[typeId];
  return {name: 'unknown[' + typeId + ']', colour: colors.grey[600]};
};

export const WcvLogCodes = {
  SYSTEM_GENERIC_LOG: 'S000',
  SYSTEM_SCHECULE_RUN: 'S100',
  SCHEDULE_LAST_LOGIN_RUN: 'S101',
  SCHEDULE_DISABLE_RESOURCE: 'S102',

  USER_LOGIN_SUCCESS: 'U100',
  USER_LOGIN_FAIL: 'U101',
  USER_LOGIN_IMPERSONATE_SUCCESS: 'U102',
  USER_LOGIN_IMPERSONATE_FAIL: 'U103',
  USER_LOGOUT: 'U104',
  USER_REGISTER_FAIL: 'U105',
  USER_REGISTER_SUCCESS: 'U106',
  USER_VERIFY_EMAIL_SEND_FAIL: 'U107',
  USER_VERIFY_EMAIL_SEND_SUCCESS: 'U108',
  USER_VERIFY_EMAIL_FAIL: 'U109',
  USER_VERIFY_EMAIL_SUCCESS: 'U110',
  USER_CREATED: 'U111',
  USER_DELETED: 'U112',
  USER_UPDATED: 'U113',
  USER_PERMISSION_ADDED: 'U114',
  USER_PERMISSION_REMOVED: 'U115',
  USER_ROLE_ADDED: 'U116',
  USER_ROLE_REMOVED: 'U117',
  USER_DAYS_SINCE_LOGIN: 'U118',
  USER_EMAIL_SEND_FAIL: 'U119',
  USER_SMS_SEND_FAIL: 'U120',

  PAGE_VIEW: 'PAGE_VIEW',
  ADD_NOTE: 'N001',

  ROLE_CREATED: 'R100',
  ROLE_UPDATED: 'R101',
  ROLE_DELETED: 'R102',
  ROLE_PERMISSION_ADDED: 'R103',
  ROLE_PERMISSION_REMOVED: 'R104',

  COMMUNICATION_CREATED: 'C100',
  COMMUNICATION_UPDATED: 'C101',
  COMMUNICATION_DELETED: 'C102',
  COMMUNICATION_SENT: 'C103',
  COMMUNICATION_SEND_EMAIL: 'C104',
  COMMUNICATION_SEND_SMS: 'C105',
  COMMUNICATION_SEND_FAIL: 'C106',

  SERVICE_OFFICE365_FETCH_STARTED: 'SV100',
  SERVICE_OFFICE365_FETCH_COMPLETE: 'SV101',

  REPORT_CREATED: 'RP100',
  REPORT_UPDATED: 'RP101',
  REPORT_DELETED: 'RP102',

  RESOURCE_CREATED: 'RS100',
  RESOURCE_UPDATED: 'RS101',
  RESOURCE_DELETED: 'RS102',
  RESOURCE_CREATE_BANKS: 'RS103',
  RESOURCE_AUTO_DISABLED: 'RS104',

  RESOURCE_BANK_CREATED: 'RB100',
  RESOURCE_BANK_UPDATED: 'RB101',
  RESOURCE_BANK_DELETED: 'RB102',
  RESOURCE_BANK_CONSUMED: 'RB103',
  RESOURCE_BANK_WARNING_COUNT: 'RB104',

  RESOURCE_OPTION_CREATED: 'RO100',
  RESOURCE_OPTION_UPDATED: 'RO101',
  RESOURCE_OPTION_DELETED: 'RO102',

  GROUP_CREATED: 'GR100',
  GROUP_UPDATED: 'GR101',
  GROUP_DELETED: 'GR102',
  GROUP_JOINING_MEMBER: 'GR115',
  GROUP_LEAVING_MEMBER: 'GR116',
  GROUP_CANCELLED_MEMBER: 'GR117',
  GROUP_UNCANCELLED_MEMBER: 'GR118',
  GROUP_HAS_MEMBER_OPTION_ADDED: 'GR120',
  GROUP_HAS_MEMBER_OPTION_REMOVED: 'GR121',
  GROUP_HAS_MEMBER_OPTION_CHANGED: 'GR122',
  GROUP_HAS_ROOM_OPTION_ADDED: 'GR123',
  GROUP_HAS_ROOM_OPTION_REMOVED: 'GR124',
  GROUP_HAS_ROOM_OPTION_CHANGED: 'GR125',

  GROUP_MEMBER_CREATED: 'GM100',
  GROUP_MEMBER_UPDATED: 'GM101',
  GROUP_MEMBER_DELETED: 'GM102',
  GROUP_MEMBER_NO_ROOM: 'GM103',
  GROUP_MEMBER_AUTHORIZED: 'GM104',
  GROUP_MEMBER_UNAUTHORIZED: 'GM105',
  GROUP_MEMBER_CANCELLED: 'GM106',
  GROUP_MEMBER_UNCANCELLED: 'GM107',
  GROUP_MEMBER_OPTION_ADDED: 'GM108',
  GROUP_MEMBER_OPTION_REMOVED: 'GM109',
  GROUP_MEMBER_OPTION_CHANGED: 'GM110',

  GROUP_BOOKING_CREATED: 'GB100',
  GROUP_BOOKING_UPDATED: 'GB101',
  GROUP_BOOKING_DELETED: 'GB102',
  GROUP_BOOKING_ACCEPT_TAC: 'GB103',

  ROOM_PARTY_MEMBER_OPTION_CREATED: 'RPMO100',
  ROOM_PARTY_MEMBER_OPTION_UPDATED: 'RPMO101',
  ROOM_PARTY_MEMBER_OPTION_DELETED: 'RPMO102',

  ROOM_PARTY_OPTION_CREATED: 'RPO100',
  ROOM_PARTY_OPTION_UPDATED: 'RPO101',
  ROOM_PARTY_OPTION_DELETED: 'RPO102',

  ROOM_PARTY_CREATED: 'RPA100',
  ROOM_PARTY_UPDATED: 'RPA101',
  ROOM_PARTY_DELETED: 'RPA102',
  ROOM_PARTY_NO_ROOM_RESOURCE: 'RPA103',
  ROOM_PARTY_ROOM_RESOURCE_EXISTS: 'RPA104',
  ROOM_PARTY_OVER_MAX_OCCUPANTS: 'RPA105',
  ROOM_PARTY_HAS_OPTION_ADDED: 'RPA106',
  ROOM_PARTY_HAS_OPTION_REMOVED: 'RPA107',
  ROOM_PARTY_HAS_OPTION_CHANGED: 'RPA108',

  ROOM_PARTY_MEMBER_CREATED: 'RPM100',
  ROOM_PARTY_MEMBER_UPDATED: 'RPM101',
  ROOM_PARTY_MEMBER_DELETED: 'RPM102',

  BILLING_PARTY_CREATED: 'BP100',
  BILLING_PARTY_UPDATED: 'BP101',
  BILLING_PARTY_DELETED: 'BP102',
  BILLING_PARTY_SOFT_CANCELLED: 'BP103',
  BILLING_PARTY_CANCELLED: 'BP104',
  BILLING_PARTY_PAYMENT_OVERDUE: 'BP105',
  BILLING_PARTY_PAYMENT_RECEIVED: 'BP106',
  BILLING_PARTY_PAYMENT_COMPLETED: 'BP107',
  BILLING_PARTY_PAYMENT_SCHEDULE_UPDATED: 'BP108',
  BILLING_PARTY_PAYMENT_REMINDER: 'BP109',
  BILLING_PARTY_PAYMENT_DUE: 'BP110',
  BILLING_PARTY_PAYMENT_FAILED: 'BP111',
  BILLING_PARTY_ACCEPT_TAC: 'BP117',

  BILLING_PARTY_MEMBER_CREATED: 'BPM100',
  BILLING_PARTY_MEMBER_UPDATED: 'BPM101',
  BILLING_PARTY_MEMBER_DELETED: 'BPM102',
  BILLING_PARTY_MEMBER_DOCUMENT_DUE_TODAY: 'BPM103',
  BILLING_PARTY_MEMBER_DOCUMENT_REMINDER: 'BPM104',
  BILLING_PARTY_MEMBER_DOCUMENT_PASTDUE: 'BPM105',

  DOCUMENT_DUE_TODAY: 'DOC104',

  AUTOMATIC_PAYMENT_CREATED: 'AUTOPAY100',
  AUTOMATIC_PAYMENT_UPDATED: 'AUTOPAY101',
  AUTOMATIC_PAYMENT_DELETED: 'AUTOPAY102',
  AUTOMATIC_PAYMENT_PAYMENT_PROCESSING: 'AUTOPAY103',
  AUTOMATIC_PAYMENT_PAYMENT_PROCESSED: 'AUTOPAY104',
  AUTOMATIC_PAYMENT_PAYMENT_FAILED: 'AUTOPAY105',

  EMAIL_MGMT_CREATED: 'EMGMT100',
  EMAIL_MGMT_UPDATED: 'EMGMT101'
};
